import { PORTFOLIO_QUERY } from "@/apollo/queries";
import Banner from "@/components/Banner";
import SimpleCard from "@/components/Card";
import BlogCard from "@/components/Card/BlogCard";
import Loader from "@/components/Loader";
import SEOHead from "@/components/SEO";

import { gql, useQuery } from "@apollo/client";
import client from "@/apollo-client";
import { Box, Container, Flex, Grid, Text } from "@chakra-ui/react";
import React from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import {
  BANNER_FRAGMENT,
  IMAGE_FRAGMENT,
  SECTION_2_FRAGMENT,
  SEO_FRAGMENT,
  TITLE_ICON_FRAGMENT,
} from "@/apollo/fragments";

const Portfolio = (props) => {
  const { Sections, SEO, MainSec } = props;
  const { data, loading, error } = useQuery(PORTFOLIO_QUERY);

  if (loading) return <Loader />;

  const { Contact_Us } = data.portfolio.data.attributes;

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Banner data={MainSec} />
      <Box
        backgroundImage={"linear-gradient(to bottom, #fafafa , #fff)"}
        pt={{ base: 8, md: 10 }}
        px={{ base: 5, md: 8, xl: 5 }}
      >
        <Box as={Container} maxW="7xl" p={0}>
          <Flex wrap={"wrap"} justify={"start"} textAlign={"start"}>
            {Sections.map((item, index) => {
              const { Title, Description, TitleIconSection, slug, desc_rich } =
                item;
              return (
                <Box
                  _notLast={{
                    mb: { base: 8, md: 10 },
                  }}
                  key={index}
                >
                  <Text
                    id={slug}
                    fontSize={{ base: "2xl", md: "3xl" }}
                    fontWeight={"medium"}
                    pos={"relative"}
                    textAlign={"left"}
                    w={"full"}
                    color={"blue.10"}
                    mb={6}
                    scrollMarginTop={100}
                    _before={{
                      content: '""',
                      pos: "absolute",
                      bottom: "-10px",
                      borderColor: "orange.10",
                      borderWidth: "2px",
                      width: "20",
                    }}
                  >
                    {Title}
                  </Text>
                  <Box mb={10} className="portfolio_info">
                    <ReactMarkdown
                      fontSize={"md"}
                      fontWeight={"normal"}
                      className="chakra-text"
                      color={"gray.10"}
                      children={desc_rich}
                    />
                  </Box>
                  {/* <Grid
                    templateColumns={{
                      base: "repeat(1, 1fr)",
                      sm: "repeat(2, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(3, 1fr)",
                      xl:"repeat(4, 1fr)",
                    }}
                    gap={{base:8,md:4}}
                    justifyItems={"center"}
                  > */}
                  <Flex
                    justifyContent={"center"}
                    flexWrap={{
                      base: "wrap",
                      lg: "wrap",
                      md: "wrap",
                      xl: "nowrap",
                    }}
                  >
                    {TitleIconSection.map((ele, index) => {
                      const newObj = { ...ele, Image: ele.Icon };
                      return (
                        <SimpleCard data={ele} showIcon={true} key={index} />
                      );
                    })}
                  </Flex>
                  {/* </Grid> */}
                </Box>
              );
            })}
          </Flex>
        </Box>
      </Box>
      <Banner data={Contact_Us} classNamechild />
    </>
  );
};

export default Portfolio;

// ssr
export async function getServerSideProps() {
  const { data } = await client.query({
    query: gql`
      query PortfolioQuery($titleIconSectionPagination: PaginationArg) {
        portfolio {
          data {
            attributes {
              Sections {
                ...Section2
              }
              SEO {
                ...SEO
              }
              MainSec {
                Title
                Description
                banner_image {
                  ...Image
                }
              }
            }
          }
        }
      }
      ${IMAGE_FRAGMENT}
      ${SEO_FRAGMENT}
      ${SECTION_2_FRAGMENT}
      ${TITLE_ICON_FRAGMENT}
    `,
  });

  const { Sections, SEO, MainSec } = data.portfolio.data.attributes;

  return {
    props: { Sections, SEO, MainSec },
  };
}
